import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col, Card, Badge, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { updateSetting } from "../../../services/settingsService";
import { oneKlicks } from "../../../SDK/oneclick";
import Paginationnew from "../../../Uitiles/Paginationnew";

const SEO = ({ seo, setSeo }) => {
    const [localSeo, setLocalSeo] = useState({
        // Global SEO Settings
        id: '',
        site_title: '',
        site_description: '',
        site_keywords: '',
        site_author: '',
        site_robots: 'index, follow',
        site_canonical: '',

        // Open Graph
        og_title: '',
        og_description: '',
        og_image: '',
        og_type: 'website',
        og_site_name: '',
        og_locale: 'en_US',

        // Twitter Card
        twitter_card: 'summary_large_image',
        twitter_site: '',
        twitter_creator: '',
        twitter_title: '',
        twitter_description: '',
        twitter_image: '',

        // Analytics
        google_analytics: '',
        google_tag_manager: '',
        facebook_pixel: '',
        google_ads: '',

        // Schema.org
        schema_type: 'Organization',
        schema_name: '',
        schema_description: '',
        schema_url: '',
        schema_logo: '',
        schema_contact_point: '',
        schema_same_as: '',

        // Custom Meta
        custom_meta_tags: '',
        custom_head_code: '',
        custom_body_code: '',

        // Page SEO
        page_title: '',
        page_path: '',
        page_id: '',

        cronical_title: '',
        cronical_description: '',
        cronical_keywords: '',
        cronical_image: '',
        cronical_url: '',
        cronical_type: '',
        cronical_site_name: '',

        // Pages
        pages: {}
    });

    const [selectedPage, setSelectedPage] = useState(null);
    const [showAddPageModal, setShowAddPageModal] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [pagedata, setPagedata] = useState(1);
    const [limitdata, setLimitdata] = useState(10);
    const [isEdit, setIsEdit] = useState(false);
    const [isEditid, setIsEditid] = useState('');
    const [totalPagesdata, setTotalPagesdata] = useState(1);
    const [seodata, setSeodata] = useState([]);
    const [showGlobalSeoModal, setShowGlobalSeoModal] = useState(false);
    const [newPage, setNewPage] = useState({
        path: '',
        title: '',
        description: '',
        type: 'page'
    });

    // Define available routes/pages
    const [availableRoutes, setAvailableRoutes] = useState([]);


    useEffect(() => {
        getpagelist();
        getseodata();
    }, []);

    useEffect(() => {
        getpagelist();
        getseodata();
    }, [page, limit, pagedata, limitdata]);

    useEffect(() => {
        if (seo && Object.keys(seo).length > 0) {
            setLocalSeo(prev => ({ ...prev, ...seo }));
        }
    }, [seo]);

    const getpagelist = async () => {
        try {
            const tableSchema = '';
            const tableName = 'seo_pages';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = {};
            const pagination = { page: page, limit: limit };
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setAvailableRoutes(response.data);
                setTotalPages(response.totalPages);
            } else {
                toast.error('Failed to get page list ' + response.message);
                setAvailableRoutes([]);
                setTotalPages(1);
            }

        } catch (error) {
            toast.error('Failed to get page list ' + error);
        }
    }

    const getseodata = async (pageId = null) => {
        try {
            const tableSchema = '';
            const tableName = 'seo_data';
            const conditions = {
                ...(pageId ? { page_id: pageId } : {})
            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = { page: pagedata, limit: limitdata };
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                // response.data is a list; do not merge into localSeo
                setSeodata(response.data);
                setTotalPagesdata(response.totalPages);
            } else {
                toast.error('Failed to get SEO data ' + response.message);
            }
        } catch (error) {
            toast.error('Failed to get SEO data ' + error);
        }
    }

    const handleChange = (field, value) => {
        const updated = { ...localSeo, [field]: value };
        setLocalSeo(updated);
        setSeo(updated);
    };

    const handlePageSelect = async (page, isEdit = false) => {
        try {
            if (!page) {
                setSelectedPage(null);
                setIsEdit(false);
                setIsEditid('');
                return;
            }

            // Normalize selected page object for consistent UI usage
            const normalized = isEdit
                ? { id: page.page_id, path: page.page_path, title: page.page_title, source: 'seo_data' }
                : { id: page.id, path: page.path, title: page.title, source: 'seo_pages' };

            setSelectedPage(normalized);

            const tableSchema = '';
            const tableName = 'seo_data';
            const conditions = { page_id: normalized.id };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = { page: 1, limit: 1 };
            const margedata = [];
            const pageSeo = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (pageSeo.success && pageSeo.data.length > 0) {
                const item = pageSeo.data[0];
                setLocalSeo(prev => ({ ...prev, ...item }));
                setIsEdit(true);
                setShowGlobalSeoModal(true);
                setIsEditid(normalized.id);
            } else {
                setIsEdit(false);
                setShowGlobalSeoModal(true);
                setIsEditid(normalized.id);
                setLocalSeo(prev => ({
                    ...prev,
                    id: '',
                    title: '',
                    description: '',
                    keywords: '',
                    og_title: '',
                    og_description: '',
                    og_image: '',
                    twitter_title: '',
                    twitter_description: '',
                    twitter_image: '',
                    page_id: normalized.id,
                    page_path: normalized.path,
                    page_title: normalized.title,
                }));
            }
        } catch (error) {
            console.log('handlePageSelect error :', error);
            toast.error("Failed to get page SEO data: " + error);
        }
    };

    const handleAddPage = async () => {
        if (!newPage.path || !newPage.title) {
            toast.error("Please fill in path and title");
            return;
        }

        const pageExists =
            availableRoutes.some(p => p.path === newPage.path) ||
            Object.keys(localSeo.pages || {}).includes(newPage.path);

        if (pageExists) {
            toast.error("Page with this path already exists");
            return;
        }

        // Add id to the new page
        const pageData = { ...newPage, id: Date.now() };

        try {
            const response = await oneKlicks.create('', 'seo_pages', pageData, {});

            if (response.success) {
                toast.success("Page added successfully");

                // Update local SEO state
                const updatedPages = { ...localSeo.pages, [newPage.path]: pageData };
                setLocalSeo(prev => ({ ...prev, pages: updatedPages }));

                getpagelist();
                setNewPage({ path: '', title: '', description: '', type: 'page' });
                setShowAddPageModal(false);
            } else {
                toast.error("Failed to add page: " + response.message);
            }
        } catch (err) {
            toast.error("Error while adding page: " + err.message);
        }
    };


    const handleSavePageSeo = async (pagePath, pageId, data, isEdit = false) => {
        console.log('handleSavePageSeo :', pagePath, pageId, data, isEdit);
        console.log('handleSavePageSeo isEdit :', isEdit);
        console.log('handleSavePageSeo isEditid :', isEditid);
        console.log('handleSavePageSeo pageId :', pageId);
        console.log('handleSavePageSeo pagePath :', pagePath);
        console.log('handleSavePageSeo data :', data);
        console.log('handleSavePageSeo localSeo :', localSeo);

        try {
            const pageSeo = {
                title: localSeo.title || '',
                description: localSeo.description || '',
                keywords: localSeo.keywords || '',
                og_title: localSeo.og_title || '',
                og_description: localSeo.og_description || '',
                og_image: localSeo.og_image || '',
                twitter_title: localSeo.twitter_title || '',
                twitter_description: localSeo.twitter_description || '',
                twitter_image: localSeo.twitter_image || '',
                cronical_title: localSeo.cronical_title || '',
                cronical_description: localSeo.cronical_description || '',
                cronical_keywords: localSeo.cronical_keywords || '',
                cronical_image: localSeo.cronical_image || '',
                cronical_url: localSeo.cronical_url || '',
                cronical_type: localSeo.cronical_type || '',
                cronical_site_name: localSeo.cronical_site_name || '',
                page_id: pageId,
                page_path: pagePath,
                page_title: data.title || ''
            };
            console.log('handleSavePageSeo pageSeo :', pageSeo);
            console.log('handleSavePageSeo isEdit :', isEdit);
            console.log('handleSavePageSeo pageId :', pageId);
            console.log('handleSavePageSeo pagePath :', pagePath);
            console.log('handleSavePageSeo data :', data);
            console.log('handleSavePageSeo localSeo :', localSeo);

            let response = {};
            if (isEdit) {
                const tableSchema = '';
                const tableName = 'seo_data';
                const data = pageSeo;
                const condition = { page_id: pageId };
                response = await oneKlicks.update(tableSchema, tableName, data, condition);
            } else {
                const tableSchema = '';
                const tableName = 'seo_data';
                const data = pageSeo;
                const condition = { page_id: pageId };
                response = await oneKlicks.create(tableSchema, tableName, data, condition);
            }
            if (response.success) {
                toast.success(`SEO settings saved for ${selectedPage?.title || pagePath}`);
                // Keep localSeo as controlled state; merge saved values
                setLocalSeo(prev => ({ ...prev, ...pageSeo }));
                setIsEdit(true);
                setShowGlobalSeoModal(false);
                setIsEditid(pageId);
                getseodata();
            } else {

                toast.error("Failed to save SEO settings: " + response.message);
            }
        } catch (error) {
            console.error("Error saving page SEO:", error);
            toast.error("Failed to save page SEO settings");
        }
    };

    const handleSave = async () => {
        try {
            const updates = Object.keys(localSeo).map(key =>
                updateSetting(key, localSeo[key])
            );

            const results = await Promise.all(updates);
            const allSuccessful = results.every(result => result);

            if (allSuccessful) {
                toast.success("SEO settings saved successfully!");
            } else {
                toast.error("Some SEO settings failed to save");
            }
        } catch (error) {
            console.error("Error saving SEO settings:", error);
            toast.error("Failed to save SEO settings");
        }
    };

    const resetToDefault = () => {
        const defaultValues = {
            site_title: '',
            site_description: '',
            site_keywords: '',
            site_author: '',
            site_robots: 'index, follow',
            site_canonical: '',
            og_title: '',
            og_description: '',
            og_image: '',
            og_type: 'website',
            og_site_name: '',
            og_locale: 'en_US',
            twitter_card: 'summary_large_image',
            twitter_site: '',
            twitter_creator: '',
            twitter_title: '',
            twitter_description: '',
            twitter_image: '',
            google_analytics: '',
            google_tag_manager: '',
            facebook_pixel: '',
            google_ads: '',
            schema_type: 'Organization',
            schema_name: '',
            schema_description: '',
            schema_url: '',
            schema_logo: '',
            schema_contact_point: '',
            schema_same_as: '',
            custom_meta_tags: '',
            custom_head_code: '',
            custom_body_code: '',
            cronical_title: '',
            cronical_description: '',
            cronical_keywords: '',
            cronical_image: '',
            cronical_url: '',
            cronical_type: '',
            cronical_site_name: '',
            // Page SEO
            page_title: '',
            page_path: '',
            page_id: '',

            // Pages
            pages: {}
        };
        setLocalSeo(defaultValues);
        setSeo(defaultValues);
        toast.info("SEO settings reset to default.");
    };

    const handleDeletePage = async (page) => {
        try {
            const response = await oneKlicks.delete('', 'seo_pages', { id: page.id });
            if (response.success) {
                toast.success("Page deleted successfully");
                getpagelist();
            } else {
                toast.error("Failed to delete page");
                toast.error("Failed to delete page" + response.message);
            }
        } catch (error) {
            toast.error("Failed to delete page" + error);
        }
    };

    const handleDeleteseodata = async (pageId) => {
        try {
            const response = await oneKlicks.delete('', 'seo_data', { page_id: pageId });
            if (response.success) {
                toast.success("SEO data deleted successfully");
                getseodata();
            } else {
                toast.error("Failed to delete SEO data: " + response.message);
            }
        } catch (error) {
            toast.error("Failed to delete SEO data: " + error);
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show">
                <div className="dc-yourdetails dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>SEO Management</h3>
                        <p>Manage SEO settings for your website pages</p>
                    </div>

                    {/* Page Selection */}
                    <div className="seo-page-selection" style={{ marginBottom: '30px' }}>
                        <h4 style={{ marginBottom: '15px' }}>Select Page to Manage SEO</h4>

                        <Row>
                            <Col md={8}>
                                <Form.Group>
                                    <Form.Label>Available Pages</Form.Label>
                                    <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                                        {availableRoutes.map((route, index) => (
                                            <div key={index} style={{
                                                padding: '8px',
                                                borderBottom: '1px solid #eee',
                                                cursor: 'pointer',
                                                backgroundColor: selectedPage?.path === route.path ? '#e3f2fd' : 'transparent'
                                            }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div>
                                                        <strong onClick={() => handlePageSelect(route, false)}>{route.title}</strong>
                                                        <br />
                                                        <small style={{ color: '#666' }}>{route.path}</small>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            size="sm"
                                                            variant="outline-primary"
                                                            disabled
                                                            style={{ marginRight: '5px' }}
                                                        >
                                                            {route.type}
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            variant="outline-primary"
                                                            onClick={() => handleDeletePage(route)}
                                                            style={{ marginRight: '5px' }}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Form.Group>
                                <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={setPage} />
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Add Custom Page</Form.Label>
                                    <Button
                                        variant="outline-primary"
                                        onClick={() => setShowAddPageModal(true)}
                                        style={{ width: '100%' }}
                                    >
                                        + Add Custom Page
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Custom Pages
                        {localSeo.pages && Object.keys(localSeo.pages).length > 0 && (
                            <div style={{ marginTop: '20px' }}>
                                <h5>Custom Pages</h5>
                                <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                                    {Object.entries(localSeo.pages).map(([path, page]) => (
                                        <div key={path} style={{
                                            padding: '8px',
                                            borderBottom: '1px solid #eee',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                            <div>
                                                <strong>{page.title}</strong>
                                                <br />
                                                <small style={{ color: '#666' }}>{path}</small>
                                            </div>
                                            <div>
                                                <Button
                                                    size="sm"
                                                    variant="outline-primary"
                                                    onClick={() => handlePageSelect(page)}
                                                    style={{ marginRight: '5px' }}
                                                >
                                                    Edit
                                                </Button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )} */}
                    </div>


                    {/* Global SEO Settings */}
                    <div className="global-seo-settings" style={{ marginTop: '30px' }}>
                        <h4>Global SEO Settings</h4>
                        <p>These settings apply to all pages unless overridden by page-specific settings.</p>

                        <Form.Group>
                            <div style={{ overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                                {seodata.map((route, index) => (
                                    <div key={index} style={{
                                        padding: '8px',
                                        borderBottom: '1px solid #eee',
                                        cursor: 'pointer',
                                        backgroundColor: selectedPage?.id === route.page_id ? '#e3f2fd' : 'transparent'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ maxWidth: '200px', width: '22%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                <strong onClick={() => handlePageSelect(route, true)}>{route.page_title}</strong>
                                                <br />
                                                <small style={{ color: '#666' }}>{route.page_path}</small>
                                            </div>
                                            <div style={{ maxWidth: '200px', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                <small style={{ color: '#666' }}>{route.page_title}</small>
                                            </div>
                                            <div>
                                                <Button
                                                    size="sm"
                                                    variant="outline-primary"
                                                    onClick={() => handlePageSelect(route, true)}
                                                    style={{ marginRight: '5px' }}
                                                >
                                                    Edit
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    variant="outline-primary"
                                                    onClick={() => handleDeleteseodata(route.page_id)}
                                                    style={{ marginRight: '5px' }}
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Form.Group>
                        <Paginationnew currentPage={pagedata} totalPages={totalPagesdata} handlePageChange={setPagedata} />
                    </div>
                </div>
            </div>

            {/* Global SEO Settings */}

            {selectedPage && (
                <Modal show={showGlobalSeoModal} onHide={() => setShowGlobalSeoModal(false)} width="80%" style={{ maxWidth: '100%' }} className="global-seo-settings-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Global SEO Settings for: {selectedPage.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Page Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Page Title"
                                            value={localSeo.title || ''}
                                            onChange={(e) => handleChange('title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Meta Description</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Meta Description"
                                            value={localSeo.description || ''}
                                            onChange={(e) => handleChange('description', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Keywords</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="keyword1, keyword2, keyword3"
                                            value={localSeo.keywords || ''}
                                            onChange={(e) => handleChange('keywords', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>OG Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Open Graph Title"
                                            value={localSeo.og_title || ''}
                                            onChange={(e) => handleChange('og_title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>OG Description</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            placeholder="Open Graph Description"
                                            value={localSeo.og_description || ''}
                                            onChange={(e) => handleChange('og_description', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>OG Image URL</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="https://yoursite.com/og-image.jpg"
                                            value={localSeo.og_image || ''}
                                            onChange={(e) => handleChange('og_image', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Twitter Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Twitter Card Title"
                                            value={localSeo.twitter_title || ''}
                                            onChange={(e) => handleChange('twitter_title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Twitter Description</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Twitter Card Description"
                                            value={localSeo.twitter_description || ''}
                                            onChange={(e) => handleChange('twitter_description', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Twitter Image URL</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="https://yoursite.com/twitter-image.jpg"
                                            value={localSeo.twitter_image || ''}
                                            onChange={(e) => handleChange('twitter_image', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Title</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Crical Title"
                                            value={localSeo.cronical_title || ''}
                                            onChange={(e) => handleChange('cronical_title', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Description</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            placeholder="Crical Description"
                                            value={localSeo.cronical_description || ''}
                                            onChange={(e) => handleChange('cronical_description', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Keywords</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Crical Keywords"
                                            value={localSeo.cronical_keywords || ''}
                                            onChange={(e) => handleChange('cronical_keywords', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Image</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="Crical Image"
                                            value={localSeo.cronical_image || ''}
                                            onChange={(e) => handleChange('cronical_image', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical URL</Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="Crical URL"
                                            value={localSeo.cronical_url || ''}
                                            onChange={(e) => handleChange('cronical_url', e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Crical Type</Form.Label>
                                        <Form.Select
                                            as="select"
                                            className="form-select"
                                            value={localSeo.cronical_type || ''}
                                            onChange={(e) => handleChange('cronical_type', e.target.value)}
                                        >
                                            <option value="article">Article</option>
                                            <option value="website">Website</option>
                                            <option value="product">Product</option>
                                            <option value="service">Service</option>
                                            <option value="event">Event</option>
                                            <option value="person">Person</option>
                                            <option value="organization">Organization</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div style={{ textAlign: 'right', marginTop: '20px' }}>
                                <Button
                                    variant="secondary"
                                    onClick={() => {
                                        setLocalSeo({
                                            ...localSeo,
                                            id: '',
                                            title: '',
                                            description: '',
                                            keywords: '',
                                        });
                                        resetToDefault();
                                        setSelectedPage(null);
                                    }}
                                    style={{ marginRight: '10px' }}
                                >
                                    Reset
                                </Button>
                                <Button
                                    variant="success"
                                    onClick={() => handleSavePageSeo(selectedPage.path, selectedPage.id, localSeo, isEdit)}
                                    style={{ marginRight: '10px' }}
                                >
                                    {isEdit ? 'Update Page SEO' : 'Save Page SEO'}
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}

            {/* Add Page Modal */}
            <Modal show={showAddPageModal} onHide={() => setShowAddPageModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Custom Page</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Page Path</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="/custom-page"
                                value={newPage.path}
                                onChange={(e) => setNewPage({ ...newPage, path: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Page Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Custom Page Title"
                                value={newPage.title}
                                onChange={(e) => setNewPage({ ...newPage, title: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder="Page description"
                                value={newPage.description}
                                onChange={(e) => setNewPage({ ...newPage, description: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Page Type</Form.Label>
                            <Form.Control
                                as="select"
                                value={newPage.type}
                                onChange={(e) => setNewPage({ ...newPage, type: e.target.value })}
                            >
                                <option value="page">Page</option>
                                <option value="dashboard">Dashboard</option>
                                <option value="profile">Profile</option>
                                <option value="admin">Admin</option>
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddPageModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleAddPage}>
                        Add Page
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SEO;
